/**
 * @generated SignedSource<<72a68af8830065c4db03517aeeb5e7aa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type AssessmentStatus = "not_needed" | "incomplete" | "complete" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type eventGuestFragment$data = {
  readonly id: string;
  readonly status: string;
  readonly assessmentStatus: AssessmentStatus | null;
  readonly contact: {
    readonly id: string;
    readonly accountId: string;
    readonly firstName: string | null;
    readonly lastName: string | null;
    readonly email: string;
    readonly source: string;
  };
  readonly salesOrders: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"salesOrderFragment">;
  }>;
  readonly eventGuestAssessmentResponses: {
    readonly " $fragmentSpreads": FragmentRefs<"eventGuestAssessmentResponsesFragment">;
  } | null;
  readonly " $fragmentType": "eventGuestFragment";
};
export type eventGuestFragment$key = {
  readonly " $data"?: eventGuestFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"eventGuestFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "eventGuestFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "assessmentStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Contact",
      "kind": "LinkedField",
      "name": "contact",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accountId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "source",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SalesOrder",
      "kind": "LinkedField",
      "name": "salesOrders",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "salesOrderFragment"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EventGuestAssessmentResponses",
      "kind": "LinkedField",
      "name": "eventGuestAssessmentResponses",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "eventGuestAssessmentResponsesFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "EventGuest",
  "abstractKey": null
};
})();

(node as any).hash = "41dc2e03684245b9ec43dfab4b738091";

export default node;
